type BadgeVariant = "default" | "secondary" | "destructive" | "outline"

export const STATUS_BADGE: Record<string, { variant: BadgeVariant; label: string }> = {
  draft: { variant: "secondary", label: "Draft" },
  pending_signature: { variant: "outline", label: "Pending Signature" },
  executed: { variant: "default", label: "Executed" },
  terminated: { variant: "destructive", label: "Terminated" },
  expired: { variant: "outline", label: "Expired" },
}

export type ExpiryLevel = "expired" | "danger" | "warning" | null

/** Amber at 60 days out, red at 30, red once the end date has passed. */
export const EXPIRY_CLASS: Record<string, string> = {
  expired: "text-red-700 dark:text-red-400",
  danger: "text-red-700 dark:text-red-400",
  warning: "text-amber-700 dark:text-amber-400",
}

export function expiryLabel(level: ExpiryLevel, days: number | null): string | null {
  if (!level || days === null) return null
  if (level === "expired") {
    const overdue = Math.abs(days)
    return overdue === 0 ? "Expires today" : `Expired ${overdue}d ago`
  }
  return days === 0 ? "Expires today" : `${days}d left`
}
